/**
 * @fileoverview Where campaign design.md lives, as its own file so both
 * owning teams are on its CODEOWNERS entry.
 *
 * Changing this string retargets every Campaigns reader and writer of the
 * document at once, so the Campaigns team needs to see it change — not just
 * the instructions domain that enforces the path's read-only guard.
 */

// Where campaign design.md lived before the reserved skill, still used by hubs
// not migrated yet. Declared here because this domain enforces its lock, and
// campaigns depends on instructions, not the other way around. Read design.md
// through `CampaignDesignMdWriteService.find`, not this path, so reads pick up
// the reserved copy first.
export const CAMPAIGN_DESIGN_SYSTEM_LEGACY_PATH =
  'rules/campaigns/design-system.md';

// A skill rather than a rule, so agents load it on demand, not every turn.
export const CAMPAIGN_DESIGN_SYSTEM_SKILL_NAME = 'campaigns-design-system';

// The paths customers and agents see: each storage path without the reserved
// root.
export const CAMPAIGN_DESIGN_MD_PATH = `${CAMPAIGN_DESIGN_SYSTEM_SKILL_NAME}/DESIGN.md`;
export const CAMPAIGN_DESIGN_SYSTEM_SKILL_PATH = `${CAMPAIGN_DESIGN_SYSTEM_SKILL_NAME}/SKILL.md`;

/**
 * Root folder for documents the product owns on a site's behalf. The
 * underscore fails `isAgentSkillName`, so no customer-facing path can name it.
 */
export const CAMPAIGN_INSTRUCTIONS_ROOT_FOLDER = 'wf_campaigns';

export const CAMPAIGN_DESIGN_MD_RESERVED_FILE = {
  managedBy: 'campaigns',
  rootFolder: CAMPAIGN_INSTRUCTIONS_ROOT_FOLDER,
  path: CAMPAIGN_DESIGN_MD_PATH,
} as const;
export const CAMPAIGN_DESIGN_SYSTEM_SKILL_RESERVED_FILE = {
  managedBy: 'campaigns',
  rootFolder: CAMPAIGN_INSTRUCTIONS_ROOT_FOLDER,
  path: CAMPAIGN_DESIGN_SYSTEM_SKILL_PATH,
} as const;
